// frontend/shared-ui/src/components/Spinner.jsx
import React from "react";

export default function Spinner({ size = "md", className = "" }) {
  return (
    <span
      className={`fh-spinner fh-spinner--${size} ${className}`}
      role="status"
    />
  );
}
